var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.78,198.957h-.727c-.333-.219-.653-.461-1-.653q-28.731-15.916-57.465-31.826c-6.523-3.613-13.045-7.229-19.644-10.886Q13.9,94.515,6.851,33.4c.471-.186.8-.327,1.135-.447Q53.143,16.836,98.312.759A3.7,3.7,0,0,1,100.6.836q40.367,14.336,80.706,28.743c3.469,1.236,6.93,2.492,10.474,3.768q-7.059,61.211-14.1,122.254c-.24.14-.409.243-.582.339q-37.936,21.015-75.871,42.035C100.721,198.257,100.262,198.628,99.78,198.957ZM99.293,22.419C79.97,65.745,60.786,108.762,41.58,151.826H63.06q5.832-14.542,11.588-28.9h49.1l11.592,28.913h21.473C137.655,108.734,118.548,65.742,99.293,22.419Z",
    fill: "#1B8646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.511,64.9l16.683,40.128H82.4c5.6-13.464,11.143-26.8,16.689-40.144Z",
    fill: "#1B8646"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.1060f4387e5bb1a1225a1d2221a18078.svg";
export { ForwardRef as ReactComponent };